export const ContentfulActionTypes = {
    FETCH_CONTENTFUL_START:"FETCH_CONTENTFUL_START",
    FETCH_CONTENTFUL_SUCCESS:"FETCH_CONTENTFUL_SUCCESS",
    FETCH_CONTENTFUL_ERROR:"FETCH_CONTENTFUL_ERROR"
  }
  